import { Alert } from "@material-ui/lab";
import React from "react";
import PageSpinner from "../../../elements/spinner/PageSpinner";
import { StyledScrollTable, StyledTable, StyledTableBody, StyledTableHead } from "../../../styles/styledTable";
import ServiceExclusionItem from "./ServiceExclusionItem";

const ServiceExclusionList = ({ collection, t, notification, setNotification, setFetch }) => {
  if (!collection) {
    return <PageSpinner position="center" pt="20" pb="20" />;
  }

  if (collection.length === 0) {
    return <Alert severity="warning">{t("exclusions.table.emptyData")}</Alert>;
  }

  return (
    <StyledScrollTable>
      <StyledTable
        width="768"
        size="14"
        className="service-exclusion-table"
      >
        <StyledTableHead
          scroll="auto"
          col="4"
          className="service-exclusion-table__head"
        >
          <div>
            {t("exclusions.table.service")}
          </div>
          <div>
            {t("exclusions.table.name")}
          </div>
          <div>
            {t("exclusions.table.value")}
          </div>
          <div>
            {t("exclusions.table.actions")}
          </div>
        </StyledTableHead>
        <StyledTableBody>
          {collection && collection.map((value, key) => (
            <ServiceExclusionItem
              key={key}
              exclusion={value}
              t={t}
              notification={notification}
              setNotification={setNotification}
              setFetch={setFetch}
            />
          ))}
        </StyledTableBody>
      </StyledTable>
    </StyledScrollTable>
  );
};

export default ServiceExclusionList;